
export const GET_TERMS = `/terms-of-service`

export const TERMS_QUERY_KEYS = {
	GET_TERMS: 'getUPGRADESTATUS'
}
